import type { IconProps } from './IconTypes';

export interface ContributorsIconProps extends IconProps {
  count?: number;
}

export function ContributorsIcon({
  size = 20,
  className = '',
  'aria-label': ariaLabel = 'Contributors',
  count,
}: ContributorsIconProps) {
  return (
    <div className="relative inline-flex">
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-label={ariaLabel}
        role="img"
      >
        {/* First person (back left) */}
        <circle cx="9" cy="7" r="4" />
        <path d="M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2" />
        {/* Second person (front right) */}
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        <path d="M21 21v-2a4 4 0 0 0-3-3.85" />
      </svg>
      {count !== undefined && count > 0 && (
        <span
          className="absolute -top-1 -right-1 flex items-center justify-center min-w-[16px] h-4 px-1 text-[10px] font-semibold rounded-full bg-primary text-white"
          aria-label={`${count} contributors`}
        >
          {count > 99 ? '99+' : count}
        </span>
      )}
    </div>
  );
}
